// Field-level price scopes are gated independently. Each group lists the
// payload keys that must be dropped when the user lacks EDIT for that scope —
// otherwise the backend rejects the whole request with 422.
const COST_FIELDS = ["cost", "profit", "profit_margin"];
const REGULAR_PRICE_FIELDS = ["regular_price"];
const SALE_PRICE_FIELDS = ["sale_price"];

const stripFields = (values, fields) => {
  if (!values || typeof values !== "object" || fields.length === 0) return values;
  const drop = new Set(fields);
  const out = {};
  for (const key of Object.keys(values)) {
    if (drop.has(key)) continue;
    out[key] = values[key];
  }
  return out;
};

export const stripCostFields = (values) => stripFields(values, COST_FIELDS);

export const stripUnpermittedPriceFields = (
  values,
  { canEditCost, canEditRegularPrice, canEditSalePrice } = {},
) => {
  const drop = [];
  if (!canEditCost) drop.push(...COST_FIELDS);
  if (!canEditRegularPrice) drop.push(...REGULAR_PRICE_FIELDS);
  if (!canEditSalePrice) drop.push(...SALE_PRICE_FIELDS);
  return stripFields(values, drop);
};
